import Vue from "vue";

export const EventBus = new Vue();

export const events = {
  CHANGED_ENTITY: "changed-entity",
};
